<template>
  <tr :class="['clickable', { updated: isLastVisited(entity.id) }]" @click="goToDetail($event, entity.id)">
    <td class="no_padding drag_drop"><span></span></td>
    <td class="no_padding">
      <span
          v-if="!$_updateActionAllowed"
          class="lock"
          :title="'Globální profil zařízení. Nelze editovat.' | translate"
          v-translate>
			</span>
      <input type="checkbox"
             :id="entity.id"
             :value="entity.id"
             @click.stop
             @change="onChange"
             :checked="isChecked"
      />
      <label
          :for="entity.id"
          @click.stop
          v-translate>Vybrat
      </label>
    </td>
    <span class="lock" v-if="!$_updateActionAllowed"  :title="'Globální profil zařízení. Nelze editovat.' | translate" v-translate>Zamčeno</span>
    <td data-th="Název">
      {{ entity.name }}
    </td>
    <td data-th="Operátor" v-if="$_readActionAllowedAllOrOwnAndGlobal">
      <entity-link :id="entity.id_operator" type="operator">{{ entity.name_operator }}</entity-link>
    </td>
    <td data-th="Typy zařízení">
        <span class="dotted" @click.stop.prevent="$refs.devicetypemodalref.showModal(true)" v-if="entity.device_types.length > 0">
        {{ entity.device_types.length }}
          <modal ref="devicetypemodalref">
                <div slot="title"><translate>Typy zařízení</translate> ({{entity.device_types.length}})</div>
                <div slot="body">
                   <table class="help_table">
              <thead>
                <tr>
                  <th v-translate>Název typu</th>
                  <th v-translate>Kód</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(item, index) in entity.device_types">
                  <tr :key="index" @click.stop="showDeviceTypeDetail(item.id)">
                    <td class="nowrap"><strong>{{ item.name }}</strong></td>
                    <td class="nowrap">{{ item.code }}</td>
                  </tr>
                </template>
              </tbody>
            </table>
                </div>
              </modal>
      </span>
      <template v-else>
        {{ entity.device_types.length }}
      </template>
    </td>
    <td data-th="Počete zařízení">
      {{ entity.device_count }}
    </td>
    <td :data-th="'Vloženo' | translate" v-html="$_date_formatFull(entity.date_created)"></td>
    <td :data-th="'Upraveno' | translate" v-html="$_date_formatFull(entity.date_updated)"></td>
    <td class="no_padding edit">
      <div class="edit_inner">
        <a
            v-if="$_deleteActionAllowed"
            class="btn btn_action btn_delete"
            :title="'Smazat' | translate"
            @click.prevent.stop="emitDeleteDeviceProfile">
          <translate class="translate">Smazat</translate>
        </a>
      </div>
    </td>
  </tr>
</template>

<script>
import rowActions from "@/components/mixins/row-actions"
import links from "../../mixins/links";
import EntityLink from "../../common/EntityLink.vue";

export default {
  name: "DeviceTypeRow",
  components: { EntityLink },
  mixins: [rowActions, links],
  props: {
      entity: Object,
  },
  data() {
    return {
      moduleName: 'deviceProfiles',
      detailPageRouteName: 'deviceProfileDetail',
    }
  },
  methods: {
    emitDeleteDeviceProfile() {
      this.$emit('deleteDeviceProfile', String(this.entity.id))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceProfiles/DeviceProfileRow.vue